export default {
  title: 'PayPal (direkte)',
  description:
    'Forbind din egen PayPal-forretningskonto for at modtage PayPal-betalinger direkte til din egen sats. Opret en REST-app i PayPal Developer Dashboard, og indsæt dens Client ID og Secret nedenfor.',
  connected_description: 'Din PayPal-konto er forbundet. Betalinger udbetales direkte til den.',
  guide: {
    title: 'Sådan finder du dine PayPal-legitimationsoplysninger',
    step1: 'Log ind på PayPal Developer Dashboard med din PayPal-forretningskonto.',
    step2: 'Åbn „Apps & Credentials“, og opret en app (eller åbn din eksisterende).',
    step3: 'Kopiér appens Client ID og Secret.',
    step4: 'Indsæt dem nedenfor, og klik på „Forbind PayPal“.',
    environment_note:
      'Brug dine Live-legitimationsoplysninger til rigtige betalinger – skift mellem Sandbox/Live øverst i „Apps & Credentials“.',
    open_dashboard: 'Åbn PayPal Developer Dashboard',
  },
  status: {
    connected: 'Forbundet',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Din PayPal REST-apps Client ID',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Din PayPal REST-apps Secret',
    },
  },
  buttons: {
    connect: 'Forbind PayPal',
    disconnect: 'Afbryd forbindelsen',
  },
  toasts: {
    connected: 'PayPal er forbundet',
    connect_failed: 'PayPal kunne ikke forbindes',
    disconnected: 'PayPal-forbindelsen er afbrudt',
    disconnect_failed: 'PayPal-forbindelsen kunne ikke afbrydes',
  },
};
